module.exports = __webpack_public_path__ + "img/BainCo.c5973626.png";